var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialMailLtr = function SvgSocialMailLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.214 11.5c-5.91 0-10.714 4.805-10.714 10.714v53.572c0 5.91 4.805 10.714 10.714 10.714h53.572c5.91 0 10.714-4.805 10.714-10.714V22.214c0-5.91-4.805-10.714-10.714-10.714zm25.782 40.128L24.248 35.005a5.35 5.35 0 0 1 5.323-4.755H72.43a5.35 5.35 0 0 1 5.323 4.755L52.005 51.628c-.302.201-.653.302-1.005.302s-.703-.1-1.005-.302m4.921 4.504 22.869-14.766v21.027a5.35 5.35 0 0 1-5.357 5.357H29.57a5.35 5.35 0 0 1-5.357-5.357V41.366l22.869 14.766A7.24 7.24 0 0 0 51 57.287c1.39 0 2.746-.402 3.917-1.155"
  })));
};
export default SvgSocialMailLtr;